import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { colors } from '../../theme';

const NAV_ITEMS = [
  { path: '/',             icon: '🏠', label: 'Dashboard'        },
  { path: '/facilities',   icon: '🏥', label: 'Facilities'       },
  { path: '/scores',       icon: '🏆', label: 'Score Overview'   },
  { path: '/compare',      icon: '⚖️',  label: 'Compare'         },
  { path: '/compliance',   icon: '✅',  label: 'Compliance Matrix'},
  { path: '/certifications',icon:'🎖️', label: 'Certifications'  },
  { path: '/bmw',          icon: '🗑️', label: 'BMW Waste'        },
  { path: '/vaccination',  icon: '💉', label: 'Vaccination D8.4' },
  { path: '/alerts',       icon: '🔔', label: 'Alerts'          },
  { path: '/reports',      icon: '📊', label: 'Reports'         },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate         = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display:'flex', height:'100vh', overflow:'hidden', fontFamily:"'Segoe UI', Roboto, sans-serif", background: colors.background }}>

      {/* Sidebar */}
      <aside style={{
        width: collapsed ? 60 : 220,
        background: colors.primary[800],
        display:'flex', flexDirection:'column',
        transition:'width 0.2s', flexShrink:0, overflow:'hidden',
      }}>
        {/* Logo */}
        <div style={{ padding:'16px 14px', borderBottom:`1px solid ${colors.primary[700]}`, display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ fontSize:22 }}>🏥</span>
          {!collapsed && (
            <div>
              <div style={{ color: colors.white, fontWeight:700, fontSize:15, lineHeight:1.2 }}>Kayakalp</div>
              <div style={{ color: colors.primary[300], fontSize:11 }}>BMO Dashboard</div>
            </div>
          )}
          <button
            onClick={() => setCollapsed(!collapsed)}
            style={{ marginLeft:'auto', background:'none', border:'none', color: colors.primary[300], cursor:'pointer', fontSize:18, padding:2 }}
          >
            {collapsed ? '→' : '←'}
          </button>
        </div>

        {/* Nav links */}
        <nav style={{ flex:1, padding:'8px 0', overflowY:'auto' }}>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              style={({ isActive }) => ({
                display:'flex', alignItems:'center', gap:10,
                padding:'10px 14px', textDecoration:'none',
                color: isActive ? colors.white : colors.primary[300],
                background: isActive ? colors.primary[700] : 'transparent',
                borderLeft: isActive ? `3px solid ${colors.primary[200]}` : '3px solid transparent',
                transition:'all 0.15s', fontSize:14, whiteSpace:'nowrap',
              })}
            >
              <span style={{ fontSize:18, minWidth:24, textAlign:'center' }}>{item.icon}</span>
              {!collapsed && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        {/* User info + logout */}
        <div style={{ padding:'12px 14px', borderTop:`1px solid ${colors.primary[700]}` }}>
          {!collapsed && (
            <div style={{ marginBottom:8 }}>
              <div style={{ color: colors.white, fontSize:13, fontWeight:600 }}>{user?.name || 'BMO'}</div>
              <div style={{ color: colors.primary[300], fontSize:11 }}>{user?.block || 'Block Medical Officer'}</div>
            </div>
          )}
          <button
            onClick={handleLogout}
            style={{ width:'100%', background:'rgba(255,255,255,0.1)', border:'none', color: colors.white, borderRadius:6, padding:'7px 0', cursor:'pointer', fontSize:13, display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}
          >
            <span>🚪</span>{!collapsed && 'Log Out'}
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main style={{ flex:1, display:'flex', flexDirection:'column', overflow:'hidden' }}>
        {/* Top bar */}
        <header style={{ background: colors.white, borderBottom:`1px solid ${colors.divider}`, padding:'12px 24px', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
          <div>
            <span style={{ fontSize:13, color: colors.text.secondary }}>NHM Madhya Pradesh · Block Medical Officer</span>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:16 }}>
            <span style={{ fontSize:13, color: colors.text.secondary }}>{new Date().toLocaleDateString('en-IN', { day:'numeric', month:'long', year:'numeric' })}</span>
            <div style={{ width:32, height:32, borderRadius:'50%', background: colors.primary[100], display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:700, color: colors.primary[700] }}>
              {(user?.name || 'B')[0].toUpperCase()}
            </div>
          </div>
        </header>

        {/* Page content */}
        <div style={{ flex:1, overflowY:'auto', padding:24 }}>
          {children}
        </div>
      </main>
    </div>
  );
}
